const basicDetailsSchema = Object.seal({
    feilds: [{
        id: 1,
        name: 'comment',
        title: 'Comment *',
        visible: true,
        element: 'textarea',
        required: false,
        type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [{
            test: (value) => {
                return (value !== null && value.length > 0 && value != '');
            },
            message: 'Please Enter Your Comments'
        }],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: true,
        className: 'col-3 mt-3'
    }]
})

export { basicDetailsSchema };